import { Injectable, ElementRef } from '@angular/core'

export interface SidepanelController {
  showSidePanel: boolean
  sidePanel: ElementRef
  closeSidePanel(): void
}

@Injectable({
  providedIn: 'root',
})
export class SidepanelService {
  private registeredComponents: Map<any, SidepanelController> = new Map()

  constructor() {
    // Set up global event listeners
    document.addEventListener('keydown', this.onEscapeKey.bind(this))
    document.addEventListener('click', this.onDocumentClick.bind(this))
  }

  /**
   * Register a component with sidepanel functionality
   */
  register(component: any, controller: SidepanelController): void {
    this.registeredComponents.set(component, controller)
  }

  /**
   * Unregister a component (call in ngOnDestroy)
   */
  unregister(component: any): void {
    this.registeredComponents.delete(component)
  }

  private onEscapeKey(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      // Close all open sidepanels when escape is pressed
      this.registeredComponents.forEach((controller) => {
        if (controller.showSidePanel) {
          controller.closeSidePanel()
        }
      })
    }
  }

  private onDocumentClick(event: Event): void {
    // Close sidepanels when clicking outside of both table-container and side-panel
    this.registeredComponents.forEach((controller) => {
      if (controller.showSidePanel && controller.sidePanel) {
        const clickedElement = event.target as Element
        const sidePanelElement = controller.sidePanel.nativeElement
        const tableContainer = document.querySelector('.table-container')

        // Check if click is outside both table container and side panel
        const isInsideTableContainer = tableContainer && tableContainer.contains(clickedElement)
        const isInsideSidePanel = sidePanelElement.contains(clickedElement)

        if (!isInsideTableContainer && !isInsideSidePanel) {
          controller.closeSidePanel()
        }
      }
    })
  }
}
